module.exports = __webpack_public_path__ + "static/media/star-off.a7dbe68e.svg";